module.exports = __webpack_public_path__ + "img/wallpaper-mobile.974e6c9b.png";